import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { createRecipe } from './recipes.service'
import { showToast } from '@/shared/utils/toast'
import type { RecipeFormData } from './types'

export function useCreateRecipe() {
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const { t } = useTranslation('recipes')

  return useMutation({
    mutationFn: (data: RecipeFormData) => createRecipe(data),
    onSuccess: () => {
      showToast(t('create.success'))
      queryClient.invalidateQueries({ queryKey: ['recipes', 'list'] })
      navigate({ to: '/recipes' })
    },
  })
}
